// extracted by mini-css-extract-plugin
export default {"footer_end":"Footer_footer_end__H0lzB","socials":"Footer_socials__BkTPo"};